<button class="button" [class.button-primary]="buttonType() === 'primary'"
  [class.button-secondary]="buttonType() === 'secondary'" [class.button-danger]="buttonType() === 'danger'"
  [class.button-text]="buttonType() === 'text'"
  [class.button-sm]="size() === 'sm'" [class.button-md]="size() === 'md'" [class.button-lg]="size() === 'lg'"
  [class.wide]="horizontalPadding()" [type]="nativeType()" [disabled]="disabled()" (click)="emitPressed()">
  @if (loading()) {
  <span class="button-spinner" [style.width.px]="iconWidth()" [style.height.px]="iconHeight()"
    aria-hidden="true"></span>
  } @else if (preIcon()) {
  <app-icon [icon]="preIcon()!" [color]="iconColor()" [width]="iconWidth()" [height]="iconHeight()" />
  }

  <span class="button-label" [style.color]="fontColor()" [style.font-size]="fontSize()"><ng-content></ng-content></span>

  @if (postIcon()) {
  <app-icon [icon]="postIcon()!" [color]="iconColor()" [width]="iconWidth()" [height]="iconHeight()" />
  }
</button>
